/**
 * @brisa/ui · OnboardingStepHeader
 *
 * Progress bar fina (4px, 3 segments) + step label + question.
 * Sem loop animation — segment fill com transição 300ms quando step muda.
 */
import * as React from 'react';

export interface OnboardingStepHeaderProps {
  currentStep: 1 | 2 | 3;
  question: string;
  helper?: string;
  stepLabel: string; // ex: "Passo 1 de 3"
  progressLabel?: string;
}

export function OnboardingStepHeader({
  currentStep,
  question,
  helper,
  stepLabel,
  progressLabel,
}: OnboardingStepHeaderProps) {
  return (
    <header className="brisa-onboarding-header">
      <div
        className="brisa-onboarding-header__progress"
        role="progressbar"
        aria-valuenow={currentStep}
        aria-valuemin={1}
        aria-valuemax={3}
        aria-label={progressLabel ?? `${currentStep} of 3`}
      >
        {[1, 2, 3].map((s) => (
          <div
            key={s}
            className="brisa-onboarding-header__progress-segment"
            data-filled={s <= currentStep ? 'true' : 'false'}
          />
        ))}
      </div>
      <span className="brisa-onboarding-header__step-label" aria-live="polite">
        {stepLabel}
      </span>
      <h2 className="brisa-display brisa-onboarding-header__question">{question}</h2>
      {helper && <p className="brisa-onboarding-header__helper">{helper}</p>}
    </header>
  );
}
